import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import HavenSelection from "../Selection2/HavenSelection";
import DualEleganceSelection from "../Selection2/DualEleganceSelection";
import ConceptualPenthouseSelection from "../Selection2/ConceptualPenthouseSelection";
import SinpasSelection from "../Selection2/SinpasSelection";
import SinpasShow from "../InteriorDesignComponents/InteriorShow/SinpasShow";

export default function SinpasComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/sinpas/26/Salon%203.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5"> SINPAS Residences</p>

              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: architectural drawings, 3d visualization
                </span>
                <span>project duration: 5 months</span>
                <span>year of completion: 2023</span>
                <span>project location:Ankara-TURKIYE</span>
              </div>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
              src="../../Images/ResidentialImages/sinpas/21/katsalon3.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
                width: "500px",
              }}
            >
              <ParallaxImage
                src="../../Images/ResidentialImages/sinpas/26/Antre.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "850px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Diverse
                <br />
                layouts
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "850px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                modern
                <br />
                design
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "850px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                functional
                <br />
                living
              </h1>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "550px",
                width: "900px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              DIVERSE LAYOUTS AND DESIGNS RANGE FROM OPEN-PLAN SPACES THAT
              MAXIMIZE NATURAL LIGHT TO STRUCTURED LAYOUTS FOCUSED ON PRIVACY,
              ENSURING COMFORT AND PRACTICALITY FOR ALL RESIDENTS.
            </p>
          </div>

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                width: "500px",
              }}
            >
              <ParallaxImage
                src="../../Images/ResidentialImages/sinpas/26/Antre.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "450px",
              }}
            >
              Sinpas Residences is a thoughtfully planned residential project
              where various lifestyles and preferences are accommodated through
              diverse layouts and designs.
              <br />
              <br />
              Each residence within the development showcases a unique mix of
              modern architecture and thoughtfully crafted interiors, designed
              to create comfortable and welcoming living spaces. From open-plan
              layouts that maximize natural light to more structured designs
              that focus on privacy and clear layouts, the residences offer a
              variety of options to suit different needs and preferences.
              <br />
              <br />
              Our approach emphasized the connection between aesthetics and
              practicality, providing residents with homes that are not only
              visually impressive but also highly functional.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                  src="../../Images/ResidentialImages/sinpas/26/MerdivenHolub.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        {/* <section className="banner">
          <SinpasSelection />
        </section> */}

        <section className="banner">
          <div className="img"
            style={{
              height:"80vh",

            }}
          >
            <ParallaxImage
              src="../../Images/ResidentialImages/sinpas/21/Salon%2044.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                  textTransform: "capitalize",
                }}
              >
                "Diverse layouts, modern design, comfort, and functionality for
                every lifestyle.""
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <SinpasShow />
        <InteriorDesignResidentialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
